module.exports = __webpack_public_path__ + "images/bannerDE-d80d8258293b7123052252d7841fba7c.jpg";